import {Button, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface MarkHandledButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const MarkHandledButton: FC<MarkHandledButtonProps> = ({onClick, disabled}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Button
      variant="secondary"
      size="sm"
      iconPosition="end"
      icon={<Icon name="check" width={16} height={16} />}
      disabled={disabled}
      onClick={onClick}
      className="hover:bg-background-success-subtle hover:text-text-success hover:ring-border-success"
    >
      {t('view.instructions.handled.label')}
    </Button>
  );
};
